webpackJsonp([267404087596173],{

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.newBooking = newBooking;
	
	var _actionTypes = __webpack_require__(2);
	
	var _index = __webpack_require__(7);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function newBooking(token, event, note, membres, date, groupe, callback1, callback2) {
	  var data = {
	    note: note,
	    membres: membres,
	    groupe: groupe,
	    date: date
	  };
	
	  event === 'null' ? undefined : data.event = event;
	
	  return function (dispatch) {
	    dispatch({ type: _actionTypes.NEW_BOOKING_REQUEST });
	
	    return (0, _index2.default)({
	      url: ("https://api.gas.tn") + '/booking',
	      method: 'post',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json',
	        Authorization: 'Bearer ' + token
	      },
	      data: data
	    }).then(function (response) {
	      dispatch({ type: _actionTypes.NEW_BOOKING_SUCCESS, payload: response.data });
	      callback1();
	    }).catch(function (error) {
	      dispatch({ type: _actionTypes.NEW_BOOKING_FAILURE, payload: error });
	      callback2();
	    });
	  };
	}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getMenuBySlug = getMenuBySlug;
	
	var _axios = __webpack_require__(7);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actionTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getMenuBySlug(slug) {
	  return function (dispatch) {
	    dispatch({ type: _actionTypes.FETCH_MENUS_REQUEST });
	    return (0, _axios2.default)({
	      url: ("https://api.gas.tn") + '/menu/menus?slug=' + slug,
	      method: 'get'
	    }).then(function (response) {
	      dispatch({ type: _actionTypes.FETCH_MENUS_SUCCESS, payload: response.data });
	    }).catch(function (error) {
	      dispatch({ type: _actionTypes.FETCH_MENUS_FAILURE, payload: error });
	    });
	  };
	}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/artisto-logo.275bbc0b.svg";

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Panel = __webpack_require__(53);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      activeTab: 0
	    };
	
	    _this.activateTab = _this.activateTab.bind(_this);
	    return _this;
	  }
	
	  Menu.prototype.activateTab = function activateTab(index) {
	    this.setState(function (prev) {
	      return {
	        activeTab: prev.activeTab === index ? -1 : index
	      };
	    });
	  };
	
	  Menu.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'menu-' + this.props.color + ' ' + this.props.background, id: 'menu' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container pb-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'align-items-center pt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'txt-bold-40px mb-4 txt-uppercase txt-' + this.props.color },
	            'Menu'
	          ),
	          this.props.data.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion offset-md-1 col-md-10', role: 'tablist' },
	              this.props.data.map(function (item, index) {
	                return _react2.default.createElement(_Panel2.default, _extends({
	                  key: index,
	                  activeTab: _this2.state.activeTab,
	                  index: index,
	                  activateTab: _this2.activateTab.bind(null, index),
	                  color: _this2.props.color
	                }, item));
	              })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'pt-5 pb-5 txt-white' },
	            _react2.default.createElement('span', { className: 'fas fa-circle-o-notch fa-5x fa-spin' })
	          )
	        )
	      )
	    );
	  };
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _facebookTools = __webpack_require__(22);
	
	var _key = __webpack_require__(63);
	
	var _key2 = _interopRequireDefault(_key);
	
	var _profile = __webpack_require__(47);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _loginAction = __webpack_require__(36);
	
	var _reactstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthModal = function (_Component) {
	  _inherits(AuthModal, _Component);
	
	  function AuthModal(props) {
	    _classCallCheck(this, AuthModal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      modal: true,
	      error: false
	    };
	    _this.toggle = _this.toggle.bind(_this);
	    _this.responseFacebook = _this.responseFacebook.bind(_this);
	    return _this;
	  }
	
	  AuthModal.prototype.toggle = function toggle() {
	    var _this2 = this;
	
	    this.setState({
	      modal: !this.state.modal
	    }, function () {
	      return _this2.props.ToggleModal();
	    });
	  };
	
	  AuthModal.prototype.goToLogin = function goToLogin() {
	    var _this3 = this;
	
	    this.props.loginFacebook(this.state.AccessToken, function () {
	      _this3.toggle();
	    }, function () {
	      _this3.setState({
	        errorLogin: true
	      });
	    });
	  };
	
	  AuthModal.prototype.FormAuth = function FormAuth(e) {
	    var _this4 = this;
	
	    e.preventDefault();
	    this.props.signIn(document.getElementById('username').value, document.getElementById('password').value, function () {
	      _this4.toggle();
	    }, function () {
	      return _this4.setState({
	        errorLogin: true
	      });
	    });
	  };
	
	  AuthModal.prototype.responseFacebook = function responseFacebook(response) {
	    var _this5 = this;
	
	    this.setState({
	      AccessToken: response.accessToken
	    }, function () {
	      _this5.goToLogin();
	    });
	  };
	
	  AuthModal.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(
	      _reactstrap.Modal,
	      {
	        isOpen: this.state.modal,
	        toggle: this.toggle,
	        className: 'txt-white pt-x',
	        external: _react2.default.createElement(
	          'button',
	          { className: 'close', style: { position: 'absolute', top: 25, right: 25, color: 'white' } },
	          _react2.default.createElement('span', { className: 'fas fa-times' })
	        )
	      },
	      _react2.default.createElement(
	        _reactstrap.ModalBody,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pt-3 pb-3 text-center' },
	          _react2.default.createElement(
	            'form',
	            { className: 'row mb-3', onSubmit: function onSubmit(e) {
	                return _this6.FormAuth(e);
	              } },
	            _react2.default.createElement(
	              'h2',
	              { className: 'col-12 text-center mb-5' },
	              'Authentification'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 mb-3 row' },
	              _react2.default.createElement('img', { className: 'col-2', src: _profile2.default, style: { height: 20, marginTop: 15 } }),
	              _react2.default.createElement('input', { id: 'username', className: 'input-login col-10', placeholder: 'E-mail', name: 'Email', type: 'email', required: true })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 mb-3 row' },
	              _react2.default.createElement('img', { className: 'col-2', src: _key2.default, style: { height: 20, marginTop: 15 } }),
	              _react2.default.createElement('input', {
	                id: 'password',
	                className: 'input-login col-10 mb-3',
	                placeholder: 'Password',
	                name: 'Password',
	                type: 'password',
	                required: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row' },
	              _react2.default.createElement('div', { className: 'offset-2' }),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn-custom btn-silver col-4', type: 'submit', name: 'login' },
	                'Se connecter'
	              ),
	              _react2.default.createElement('div', { className: 'offset-1' }),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/login', className: 'btn-custom btn-purple col-4' },
	                'S\'inscrire'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row', hidden: !this.state.errorLogin },
	            _react2.default.createElement(
	              _reactstrap.Alert,
	              { color: 'danger', className: 'offset-2 col-8' },
	              'L\'email ou le mot de passe entr\xE9 est incorrect.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row text-center', style: { height: 50, justifyContent: 'between' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 text-center' },
	              'Ou'
	            )
	          ),
	          _react2.default.createElement(_facebookTools.Button, { scope: 'public_profile,email', callback: this.responseFacebook })
	        )
	      )
	    );
	  };
	
	  return AuthModal;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(store) {
	  return {
	    token: store.login.token,
	    user: store.login.user
	  };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { loginFacebook: _loginAction.loginFacebook, signIn: _loginAction.signIn, logout: _loginAction.logout })(AuthModal);
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactstrap = __webpack_require__(13);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BookingAction = __webpack_require__(48);
	
	var _EventsAction = __webpack_require__(23);
	
	var _ProfilAction = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookingModal = function (_Component) {
	  _inherits(BookingModal, _Component);
	
	  function BookingModal(props) {
	    _classCallCheck(this, BookingModal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      modal: true,
	      error: false,
	      email: '',
	      phone: ''
	    };
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  BookingModal.prototype.toggle = function toggle() {
	    var _this2 = this;
	
	    this.setState({
	      modal: !this.state.modal
	    }, function () {
	      return _this2.props.ToggleModal();
	    });
	  };
	
	  BookingModal.prototype.Booking = function Booking() {
	    var _this3 = this;
	
	    this.props.updateMeBooking(this.props.token, document.getElementById('phone').value, document.getElementById('email').value, function () {
	      return _this3.props.newBooking(_this3.props.token, document.getElementById('event').value, document.getElementById('note').value, document.getElementById('members').value, document.getElementById('date').value, _this3.props.eventsBySlug[0].groupe._id, function () {
	        _this3.toggle();
	        alert('Votre réservation a été envoyée avec succes. Notre équipe vérifiera la disponibilité de votre demande et répondra par téléphone ou par email dans les plus brefs délais.');
	      }, function () {
	        _this3.setState({
	          error: true
	        });
	      });
	    });
	  };
	
	  BookingModal.prototype.render = function render() {
	    var email = this.props.user.local && this.props.user.local.email ? this.props.user.local.email : this.props.user.facebook && this.props.user.facebook.email ? this.props.user.facebook.email : null;
	    return _react2.default.createElement(
	      _reactstrap.Modal,
	      {
	        isOpen: this.state.modal,
	        toggle: this.toggle,
	        className: 'txt-white pt-x',
	        external: _react2.default.createElement(
	          'button',
	          { className: 'close', style: { position: 'absolute', top: 25, right: 25, color: 'white' } },
	          _react2.default.createElement('span', { className: 'fas fa-times' })
	        )
	      },
	      _react2.default.createElement(
	        _reactstrap.ModalBody,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row mb-3' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-12 text-center mb-4' },
	            'Reservation'
	          ),
	          this.props.eventsBySlug ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-3 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'fas fa-tag' })
	            ),
	            _react2.default.createElement(
	              'select',
	              { className: 'input-login col-10', id: 'event', name: 'event', form: 'event' },
	              _react2.default.createElement(
	                'option',
	                { value: 'null', disabled: true, selected: true },
	                'Reservation hors \xE9v\xE9nements...'
	              ),
	              this.props.eventsBySlug.map(function (item) {
	                return (0, _moment2.default)().isAfter(item.date) || _react2.default.createElement(
	                  'option',
	                  { value: item._id },
	                  item.name
	                );
	              })
	            )
	          ) : _react2.default.createElement(_react.Fragment, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'fas fa-users' })
	            ),
	            _react2.default.createElement('input', {
	              id: 'members',
	              className: 'input-login col-10',
	              placeholder: 'Nombre des places',
	              type: 'number',
	              name: 'Nombre des places'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'far fa-calendar-alt' })
	            ),
	            _react2.default.createElement('input', { type: 'datetime-local', id: 'date', className: 'input-login col-10', name: 'date', min: new Date() })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'far fa-comment-alt' })
	            ),
	            _react2.default.createElement('textarea', { className: 'col-10 input-login', id: 'note', placeholder: 'Note' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Alert,
	          { color: 'info' },
	          _react2.default.createElement('span', { className: 'fas fa-info-circle', style: { marginRight: 5 } }),
	          'Vous devez rev\xE9rifier votre num\xE9ro de t\xE9l\xE9phone et votre courrier \xE9lectronique, car nous les utilisons pour r\xE9pondre \xE0 votre demande.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 mb-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'fas fa-phone' })
	            ),
	            _react2.default.createElement('input', {
	              id: 'phone',
	              required: true,
	              defaultValue: this.props.user.phone ? this.props.user.phone : '',
	              className: 'input-login col-10',
	              placeholder: 'Num\xE9ro du t\xE9l\xE9phone',
	              type: 'tel',
	              name: 'Num\xE9ro du t\xE9l\xE9phone'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'far fa-envelope-open' })
	            ),
	            _react2.default.createElement('input', {
	              id: 'email',
	              required: true,
	              defaultValue: email || '',
	              className: 'input-login p-2 col-10',
	              placeholder: 'Email',
	              type: 'email',
	              name: 'Email',
	              disabled: email
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row' },
	          _react2.default.createElement('div', { className: 'col-2' }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-custom btn-silver col-4', onClick: this.toggle },
	            'Annuler'
	          ),
	          _react2.default.createElement('div', { className: 'col-2' }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-custom btn-purple col-4', onClick: this.Booking.bind(this) },
	            'Confirmer'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'row', hidden: !this.state.error },
	          _react2.default.createElement(
	            _reactstrap.Alert,
	            { color: 'danger', className: 'offset-2 col-8' },
	            'La r\xE9servation a \xE9t\xE9 echou\xE9e.'
	          )
	        )
	      )
	    );
	  };
	
	  return BookingModal;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(store) {
	  return {
	    user: store.login.user,
	    token: store.login.token
	  };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getEvents: _EventsAction.getEvents, newBooking: _BookingAction.newBooking, updateMeBooking: _ProfilAction.updateMeBooking })(BookingModal);
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Panel = function (_Component) {
	  _inherits(Panel, _Component);
	
	  function Panel(props) {
	    _classCallCheck(this, Panel);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      height: 0
	    };
	    return _this;
	  }
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        products = _props.products,
	        name = _props.name,
	        activeTab = _props.activeTab,
	        index = _props.index,
	        activateTab = _props.activateTab;
	
	    var isActive = activeTab === index;
	    var innerStyle = {
	      height: isActive ? 'auto' : '0px'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel menu-item-' + this.props.color, role: 'tabpanel', 'aria-expanded': isActive },
	      _react2.default.createElement(
	        'button',
	        { className: 'panel-label', role: 'tab', onClick: activateTab },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-inner', style: innerStyle, 'aria-hidden': !isActive },
	        products.map(function (product) {
	          return _react2.default.createElement(
	            'div',
	            { key: product._id, className: 'row m-2' },
	            _react2.default.createElement(
	              'span',
	              { className: (product.price > 0 ? 'col-9' : 'col-12') + ' text-left' },
	              product.name
	            ),
	            product.price > 0 && _react2.default.createElement(
	              'span',
	              { className: 'col-3 text-right txt-bold' },
	              product.price + 'TND'
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return Panel;
	}(_react.Component);
	
	exports.default = Panel;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutArtisto = function (_Component) {
	  _inherits(AboutArtisto, _Component);
	
	  function AboutArtisto() {
	    _classCallCheck(this, AboutArtisto);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutArtisto.prototype.render = function render() {
	    return _react2.default.createElement(
	      "section",
	      { className: this.props.background, id: "about" },
	      _react2.default.createElement(
	        "div",
	        { className: "container mt-5 mb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "row pt-2 pb-2" },
	          _react2.default.createElement(
	            "span",
	            { className: "col-12 txt-bold-40px txt-white txt-uppercase" },
	            "Restaurant Italien"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "col-12 txt-thin" },
	            "Depuis 2013, L\u2019artisto s\u2019est tr\xE8s vite fait une place de choix dans le c\u0153ur des gourmets",
	            _react2.default.createElement("br", null),
	            "et des amateurs de la cuisine italienne.",
	            _react2.default.createElement("br", null),
	            "Rien ne vaut les valeurs italiennes dans nos assiettes : Savoureuses, authentiques et familiales.",
	            _react2.default.createElement("br", null),
	            "La carte ne se lit pas mais s\u2019\xE9coute, d\xE9clam\xE9e par le chef, rythm\xE9e par sa voix, dress\xE9e avec sa passion.",
	            _react2.default.createElement("br", null),
	            "L\u2019artisto, c\u2019est notre assortiment explosif d\u2019autenticita italiana."
	          )
	        )
	      )
	    );
	  };
	
	  return AboutArtisto;
	}(_react.Component);
	
	exports.default = AboutArtisto;
	module.exports = exports["default"];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BookingModal = __webpack_require__(52);
	
	var _BookingModal2 = _interopRequireDefault(_BookingModal);
	
	var _AuthModal = __webpack_require__(51);
	
	var _AuthModal2 = _interopRequireDefault(_AuthModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderWithBooking = function (_Component) {
	  _inherits(HeaderWithBooking, _Component);
	
	  function HeaderWithBooking() {
	    _classCallCheck(this, HeaderWithBooking);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.toggle = function () {
	      if (_this.props.token === null) _this.setState({ openModal: true });else _this.setState({ open: true });
	    };
	
	    _this.state = {
	      open: false,
	      openModal: false
	    };
	    return _this;
	  }
	
	  HeaderWithBooking.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pb-3 pt-3' },
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.icon
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: this.toggle, className: 'btn-custom btn-silver' },
	          'R\xE9servation'
	        ),
	        this.state.open === true && _react2.default.createElement(_BookingModal2.default, { ToggleModal: function ToggleModal() {
	            return _this2.setState({ open: false });
	          }, eventsBySlug: this.props.eventsBooking }),
	        this.state.openModal === true && _react2.default.createElement(_AuthModal2.default, { ToggleModal: function ToggleModal() {
	            return _this2.setState({ openModal: false });
	          } })
	      )
	    );
	  };
	
	  return HeaderWithBooking;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (store) {
	  return { token: store.login.token };
	}, {})(HeaderWithBooking);
	module.exports = exports['default'];

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _scrolling = __webpack_require__(26);
	
	var _Gallery = __webpack_require__(29);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Header = __webpack_require__(30);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NavigationBar = __webpack_require__(31);
	
	var _NavigationBar2 = _interopRequireDefault(_NavigationBar);
	
	var _Contact = __webpack_require__(27);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _AboutArtisto = __webpack_require__(248);
	
	var _AboutArtisto2 = _interopRequireDefault(_AboutArtisto);
	
	var _Menu = __webpack_require__(50);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Events = __webpack_require__(65);
	
	var _Events2 = _interopRequireDefault(_Events);
	
	var _MenusAction = __webpack_require__(49);
	
	var _EventsAction = __webpack_require__(23);
	
	var _GallerieAction = __webpack_require__(24);
	
	var _HeaderWithBooking = __webpack_require__(54);
	
	var _HeaderWithBooking2 = _interopRequireDefault(_HeaderWithBooking);
	
	var _artistoLogo = __webpack_require__(138);
	
	var _artistoLogo2 = _interopRequireDefault(_artistoLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lartisto = function (_Component) {
	  _inherits(Lartisto, _Component);
	
	  function Lartisto(props) {
	    _classCallCheck(this, Lartisto);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      menus: [],
	      images: [],
	      items: []
	    };
	    return _this;
	  }
	
	  Lartisto.prototype.componentDidMount = function componentDidMount() {
	    this.props.getGallery('lartistosousse');
	    this.props.getEventsBySlug('lartistosousse');
	    this.props.getMenuBySlug('lartistosousse');
	    var about = _reactDom2.default.findDOMNode(this.refs.about);
	    var events = _reactDom2.default.findDOMNode(this.refs.events);
	    var menu = _reactDom2.default.findDOMNode(this.refs.menu);
	    var gallery = _reactDom2.default.findDOMNode(this.refs.gallery);
	
	    this.props.savingNodesPositions({
	      lartisto: {
	        about: about.offsetTop,
	        events: events.offsetTop,
	        menu: menu.offsetTop,
	        gallery: gallery.offsetTop
	      }
	    });
	  };
	
	  Lartisto.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Header2.default,
	        {
	          content: _react2.default.createElement(_HeaderWithBooking2.default, {
	            icon: _react2.default.createElement('img', { alt: 'Logo', className: 'm-2', src: _artistoLogo2.default, style: { height: 250 } }),
	            eventsBooking: this.props.events
	          }),
	          background: 'artisto-header-bg'
	        },
	        _react2.default.createElement(_NavigationBar2.default, {
	          slug: 'lartisto',
	          navigations: [{ name: 'about', txt: 'About' }, { name: 'events', txt: 'Events' }, { name: 'menu', txt: 'Menu' }, { name: 'gallery', txt: 'Gallery' }]
	        })
	      ),
	      _react2.default.createElement(_AboutArtisto2.default, { ref: 'about', background: 'artisto-about-bg' }),
	      _react2.default.createElement(_Events2.default, { ref: 'events', background: 'artisto-event-bg', data: this.props.events }),
	      _react2.default.createElement(_Menu2.default, { ref: 'menu', background: 'artisto-menu-bg', color: 'yellow', data: this.props.menus }),
	      _react2.default.createElement(_Gallery2.default, { ref: 'gallery', background: 'artisto-gallery-bg', medias: this.props.gallerie }),
	      _react2.default.createElement(_Contact2.default, { ref: 'contact', minimal: true, color: '#fff3b8', placeholders: '#fffcd3', background: 'artisto-about-bg', info: info }),
	      _react2.default.createElement(_Footer2.default, { color: '#ceb688', secondColor: '#7a7458' })
	    );
	  };
	
	  return Lartisto;
	}(_react.Component);
	
	var info = {
	  facebook: 'https://www.facebook.com/lartistoresto/',
	  insta: 'https://www.instagram.com/explore/locations/979725783/lartisto/',
	  youtube: '',
	  tripAdvisor: 'https://www.tripadvisor.fr/Restaurant_Review-g297952-d5617378-Reviews-L_ARTISTO-Port_El_Kantaoui_Sousse_Governorate.html',
	  address: _react2.default.createElement(
	    'span',
	    null,
	    'SOCIETE " G A S " SARL 6ET, IMM "VENUS" A 6-4, Golf Advanced Services, 1082 CENTRE URB NORD'
	  )
	};
	
	exports.default = (0, _reactRedux.connect)(function (store) {
	  return {
	    scrolling: store.scrolling,
	    menus: store.menus,
	    gallerie: store.gallerie,
	    events: store.events
	  };
	}, {
	  savingNodesPositions: _scrolling.savingNodesPositions,
	  getMenuBySlug: _MenusAction.getMenuBySlug,
	  getEventsBySlug: _EventsAction.getEventsBySlug,
	  getGallery: _GallerieAction.getGallery
	})(Lartisto);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lartistosousse-jsx-7b13ae2e7159713bc3ce.js